import { useEffect } from 'react';

import { PageShell } from '../components/PageShell';
import { PriceIntelCommandCenter } from '../components/PriceIntelCommandCenter';
import { usePriceIntelStore } from '../stores/price-intel-store';

export function PriceIntelDashboardPage() {
  const { fetchJobs, fetchCandidates, fetchFacts, fetchBriefings } = usePriceIntelStore();

  useEffect(() => {
    void fetchJobs();
    void fetchCandidates();
    void fetchFacts();
    void fetchBriefings();
  }, [fetchJobs, fetchCandidates, fetchFacts, fetchBriefings]);

  return (
    <PageShell>
      <PriceIntelCommandCenter />
    </PageShell>
  );
}
